export default "__VITE_ASSET__fc7f7f09__"